
  // This file is automatically generated by generate-version.js
  export const version = '0.0.371';
